var map = {
	"./bow.webp": 2287,
	"./claymore.webp": 5171,
	"./electric.webp": 7004,
	"./fire.webp": 6003,
	"./ice.webp": 7016,
	"./magic.webp": 6106,
	"./pike.webp": 2478,
	"./stone.webp": 8314,
	"./sword.webp": 1868,
	"./water.webp": 8719,
	"./wind.webp": 3293
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9871;